import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class RoundOverPopup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} type 1 is for label, 2 is for assembly
   */
  constructor(scene, type, attempts, best) {
    super(scene);

    this.enabled = true;
    this.doAction1 = () => { };
    this.doAction2 = () => { };

    this.bg = this.scene.add.circle(0, 0, 194, 0xf99f1c);
    this.add(this.bg);

    this.header = ABCyaPhaser.Text.addText(0, -106, 46, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.header'), this);

    this.attemptsLabel = ABCyaPhaser.Text.addText(0, -54, 32, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.attempts_label'), this, false).setOrigin(0, 0.5);
    this.attemptsValue = ABCyaPhaser.Text.addText(0, -54, 32, 0xffd730, FontKeys._odin_roundedregular, attempts, this, false).setOrigin(0, 0.5);

    const attemptsWidth = this.attemptsLabel.width + this.attemptsValue.width + 10; // 10 is the buffer between the labels
    this.attemptsLabel.x = -attemptsWidth / 2;
    this.attemptsValue.x = this.attemptsLabel.x + this.attemptsLabel.width + 10;

    this.bestLabel = ABCyaPhaser.Text.addText(0, -14, 32, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.best_label'), this, false).setOrigin(0, 0.5);
    this.bestValue = ABCyaPhaser.Text.addText(0, -14, 32, 0xffd730, FontKeys._odin_roundedregular, best, this, false).setOrigin(0, 0.5);

    const bestWidth = this.bestLabel.width + this.bestValue.width + 10; // 10 is the buffer between the labels
    this.bestLabel.x = -bestWidth / 2;
    this.bestValue.x = this.bestLabel.x + this.bestLabel.width + 10;

    this.playAgainButtonBg = this.scene.add.circle(-70, 75, 52, 0xffd730).setInteractive();
    this.playAgainButtonBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick1, this);
    this.add(this.playAgainButtonBg);

    this.playAgainButtonText = ABCyaPhaser.Text.addText(this.playAgainButtonBg.x, this.playAgainButtonBg.y, 22, 0xd25f1c, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.play_again_button'), this).setWordWrapWidth(90);

    this.otherButtonBg = this.scene.add.circle(70, 75, 52, 0xffd730).setInteractive();
    this.otherButtonBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick2, this);
    this.add(this.otherButtonBg);

    const text = type === 1 ? ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.assemble_skeleton_button') : ABCyaPhaser.Localization.instance.getLocalizedString('round_over_popup.label_skeleton_button');
    this.otherButtonText = ABCyaPhaser.Text.addText(this.otherButtonBg.x, this.otherButtonBg.y, 22, 0xd25f1c, FontKeys._asapbold, text, this).setWordWrapWidth(90);
  }

  doClick1() {
    if (!this.enabled) { return; }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.doAction1();
  }

  doClick2() {
    if (!this.enabled) { return; }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.doAction2();
  }
}